import React, { useState, useContext } from "react";

import PlusIcon from "../../../icons/plus-icon";
import FeesIcon from "../../../icons/fees-icon";
import DiscountIcon from "../../../icons/discount-icon";
import BalanceIcon from "../../../icons/balance-icon";

import { PopUpContext } from "../../../contexts/popUpContext";
import useParityAccess, { useAccessReady } from "../../common/useParityAccess";

import lbl from "../../../data/Labels.json";

const FabButtons = ({ cache }) => {
  const [open, setOpen] = useState(false);
  const { togglePopUp } = useContext(PopUpContext);
  const can = useParityAccess();
  const ready = useAccessReady();
  const allow = (key) => !ready || can(key);
  const canBalance = allow("edit-student-balance");
  const canDiscount = allow("edit-student-discount");
  const canFee = allow("edit-student-fees");
  if (ready && !canBalance && !canDiscount && !canFee) return null;

  return (
    <div className={`fab-container no-padding ${open ? "active" : ""}`} style={{width: open ? "200px" : "50px"}}>
      {canBalance ? (
      <button
        className="secondary"
        onClick={() => togglePopUp({ form: "student-balance-form", cache })}
      >
        <BalanceIcon />
        <span>{lbl.OpeningBalance}</span>
      </button>
      ) : null}
      {canDiscount ? (
      <button
        className="secondary"
        onClick={() => togglePopUp({ form: "student-discount-form", cache })}
      >
        <DiscountIcon />
        <span>{lbl.Discount}</span>
      </button>
      ) : null}
      {canFee ? (
      <button
        className="secondary"
        onClick={() => togglePopUp({ form: "student-fee-form", cache })}
      >
        <FeesIcon />
        <span>{lbl.Fees}</span>
      </button>
      ) : null}
      <button className="primary" onClick={() => setOpen(!open)}>
        <PlusIcon />
        <span>{lbl.Cancel}</span>
      </button>
    </div>
  );
};

export default FabButtons;
